"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MissingParametersError = /*#__PURE__*/function (_Error) {
  _inherits(MissingParametersError, _Error);

  var _super = _createSuper(MissingParametersError);

  function MissingParametersError(message) {
    var _this;

    _classCallCheck(this, MissingParametersError);

    _this = _super.call(this);
    _this.name = 'MissingParametersError';
    _this.message = message || '';
    return _this;
  }

  return MissingParametersError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.MissingParametersError = MissingParametersError;

var InvalidTokenError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidTokenError, _Error2);

  var _super2 = _createSuper(InvalidTokenError);

  function InvalidTokenError(message) {
    var _this2;

    _classCallCheck(this, InvalidTokenError);

    _this2 = _super2.call(this);
    _this2.name = 'InvalidTokenError';
    _this2.message = message || '';
    return _this2;
  }

  return InvalidTokenError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.InvalidTokenError = InvalidTokenError;